// TODO use this in customer-data-table
// TODO change file-cell to full-width-cell
// https://git.hubteam.com/HubSpot/PropertiesFrontendTeam/issues/1899
export const fullWidthCellClassName = 'file-cell';